<template>
	<el-dialog
		title="创建联系人"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		append-to-body
		:visible.sync="dialogVisible"
		width="500px"
		:show-close="false"
		top="10vh"
	>
		<div slot="title" class="flex align-center justify-between">
			<div class="flex align-center">
				<span class="iconfont-lianxiren text-gray text-xxl"></span>
				<div class="margin-left-xs"><div class="text-bold">创建联系人</div></div>
			</div>
			<el-link :underline="false" type="info" @click="closeDialog"><i class="el-icon-close text-xxl"></i></el-link>
		</div>
		<div v-loading="loadingAdd" element-loading-text="处理中">
			<div class="padding-lr-xxl padding-tb" v-if="!contacterAddVisible">
				<div class="padding-tb text-lg text-grey">
					<i class="el-icon-info"></i>
					<span class="margin-left-xs">请输入手机号码：</span>
				</div>
				<el-input v-model="formAdd.mobile" placeholder="手机号码" autocomplete="off"></el-input>
				<div class="text-center margin-top-xl">
					<el-button type="primary" round @click="checkContacterMobile"><span>确认</span></el-button>
				</div>
			</div>
			<el-form ref="formAdd" :model="formAdd" label-width="60px" label-suffix=":" v-else>
				<div class="padding-lr margin-tb" style="max-height: 500px; overflow: auto;">
					<el-form-item label="姓名" prop="name" :rules="{ required: true, message: '请输入姓名', trigger: 'blur' }">
						<el-input v-model="formAdd.name" placeholder="姓名" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="性别" prop="gender">
						<el-radio-group v-model="formAdd.gender">
							<el-radio :label="1">男</el-radio>
							<el-radio :label="2">女</el-radio>
							<el-radio :label="0">未知</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="固话" prop="telephone"><el-input v-model="formAdd.telephone" placeholder="固定电话" autocomplete="off"></el-input></el-form-item>
					<el-form-item label="手机" prop="mobile" :rules="{ required: true, message: '请输入手机号码', trigger: 'blur' }">
						<el-input v-model="formAdd.mobile" disabled placeholder="手机号码" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="email" prop="email"><el-input v-model="formAdd.email" placeholder="Email 地址" autocomplete="off"></el-input></el-form-item>
					<el-form-item label="QQ" prop="qq"><el-input v-model="formAdd.qq" placeholder="QQ号码" autocomplete="off"></el-input></el-form-item>
					<el-form-item label="微信" prop="weixin"><el-input v-model="formAdd.weixin" placeholder="微信号码" autocomplete="off"></el-input></el-form-item>
					<el-form-item label="备注" prop="remark">
						<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="备注信息" v-model="formAdd.remark"></el-input>
					</el-form-item>
				</div>
				<div class="border-top padding-top-lg text-right">
					<el-button @click="clearFormAdd">清 除</el-button>
					<el-button type="primary" @click="formSubmitAdd">保存提交</el-button>
				</div>
			</el-form>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'select-contacter',
	props: {
		show: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		config: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {
			cfg: {},
			errorMsg: '',
			dialogVisible: false,
			loadingAdd: false,
			formAdd: {
				gender: 0,
				name: '',
				mobile: ''
			},
			contacterAddVisible: false
		};
	},
	created: function() {},
	mounted() {
		this.cfg = this.config;
		this.dialogVisible = this.show;
	},
	methods: {
		closeDialog() {
			this.dialogVisible = false;
			this.$emit('close', true);
		},
		checkContacterMobile() {
			if (!this.formAdd.mobile) {
				this.$message.error('请填写手机号码');
				return false;
			}
			this.loadingAdd = true;
			this.$http.post('/server/index.php?m=components/contacterAdd&a=checkMobile', { mobile: this.formAdd.mobile }).then(
				res => {
					this.loadingAdd = false;
					if (res.result == 'ok') {
						if (res.data.isHave) {
							this.$confirm('手机号【' + this.formAdd.mobile + '(' + res.data.info.name + ')】在系统中已存在，是否直接使用该信息?', '手机号已存在', {
								dangerouslyUseHTMLString: true,
								confirmButtonText: '使用',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(
								r => {
									this.$emit('change', res.data.info);
									this.closeDialog();
								},
								e => {
									console.log('e:', e);
								}
							);
						} else {
							this.$message('该手机号还未添加，请填写联系人信息');
							this.contacterAddVisible = true;
						}
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loadingAdd = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		clearFormAdd() {
			this.formAdd = {
				gender: 0,
				name: '',
				mobile: ''
			};
			this.contacterAddVisible = false;
		},
		formSubmitAdd() {
			this.$refs['formAdd'].validate(valid => {
				if (valid) {
					this.loadingAdd = true;
					this.$http.post('/server/index.php?m=components/contacterAdd&a=add', this.formAdd).then(
						res => {
							this.loadingAdd = false;
							if (res.result == 'ok') {
								this.$message({
									message: '新建联系人成功',
									type: 'success'
								});
								this.$emit('change', res.data);
								this.closeDialog();
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							this.loadingAdd = false;
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
				} else {
					this.$alert('请根据红色提示填写。', {
						title: '表单错误',
						type: 'error'
					});
				}
			});
		}
	},
	watch: {
		show: function(d) {
			this.dialogVisible = d;
		}
	}
};
</script>

<style>
.infoshow-list {
	display: flex;
	justify-content: space-between;
}
</style>
